module.exports = __webpack_public_path__ + "static/img/px-banner (3).7bb84572.png";